module.exports = __webpack_public_path__ + "static/media/icon_delete.096bfcd6.svg";